import React from 'react';

import SplitProvider from '@bessemercws/feature-flags';
import { useClientContext } from '@bessemercws/providers';

import { useGetUserHash } from '#/hooks/user/useGetUserHash';

export const SplitIOProvider = ({ children }: { children: JSX.Element }) => {
  const { isAdvisor, selectedClient, isAuthing } = useClientContext();
  const hash = useGetUserHash(Boolean(isAdvisor), selectedClient || null, isAuthing);

  return <SplitProvider userKey={hash || 'key'}>{children}</SplitProvider>;
};
